<template>
  <div class="app">
    <div class="swiper-out home-index">
      <div class="header" :class="{'headerOpacity':opacityActive}">
          <div class="header-content">
            <h1><img :src="groupLogo" class="logo-img" :alt="groupName"></h1>
            <div class="clearfix header-qr-right">
              <div class="icon-box fl" v-if="wbWx.wb"><img src="../assets/images/weChat.png" alt="" class="icon wh40">
                <div class="qrCodeBox">
                  <img :src="wbWx.wx" :alt="groupName" class="qrCode wh80">
                  <div class="pt12">官方微信</div>
                </div>
              </div>
              <div class="icon-box fl" v-if="wbWx.wx">
                <img src="../assets/images/weibo.png" alt="" class="icon wh40">
                <div class="qrCodeBox">
                  <img :src="wbWx.wb" :alt="groupName" class="qrCode wh80">
                  <div class="pt12">官方微博</div>
                </div>
              </div>
            </div>
          </div>
      </div>
      <div class="header-banner-box hand-shape">
        <el-carousel  trigger="click" v-if="showSwiper">
          <el-carousel-item v-for="(item,index) in banner" :key="index">
            <div @click="goUrl(item.url)" class="img-box">
              <img class="swiper-img" :src="item.img" :alt="item.description"/>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="section clearfix main-content pt40 pb40 tc">
        <div class="fl show-li mr50 pb40 pt40" v-for="(item,index) in menusList" :key="index">
          <div v-if="item.link == '/dynamic'">
            <img src="../assets/images/group.png" :alt="item.alias" class="wh40">
          </div>
          <div v-if="item.link == '/recruit'">
            <img src="../assets/images/jobOffers.png" :alt="item.alias">
          </div>
          <div v-if="item.link == '/doctorGroup'">
            <img src="../assets/images/doctors.png" :alt="item.alias">
          </div>
          <div v-if="item.link == '/tcCollege'">
            <img src="../assets/images/introduction.png" :alt="item.alias">
          </div>
          <div v-if="item.link == '/about'">
            <img src="../assets/images/aboutUs.png" :alt="item.alias">
          </div>
          <div class="pt40" v-if="item.subItems.length>0"> 
            <h2 class="title-link">{{item.alias}}</h2>
            <h3 v-for="(sub,index) in item.subItems" :key="index">
              <router-link class="part-link" :to="{path:sub.link+'/'+index+'.html'}" :title="sub.name">{{sub.name}}</router-link>
            </h3>
          </div>
          <h2 class="pt40 link-out" v-else>
              <router-link class="part-link active" :to="{path:item.link+'/0.html'}" :title="item.alias">{{item.alias}}</router-link>
          </h2>
        </div>
    </div>
  </div>
</template>
<script>
import seoArgs from '../utils/setSeoArgs';

export default {
  name: 'Index',
  components: {
		
	},
  data () {
    return {
      groupName: '',
      opacityActive:false,
      banner: [],
      menusList:[],
      wbWx:{
        wb:'',
        wx:''
      }
    }
  },
  computed: {
    // 这里计算数据的长度，以此来判断是否显示，这个貌似要必写
     showSwiper () {
       return this.banner.length
     },
     groupLogo(){
       return this.$store.getters.getGroupLogo;
     }
   },
  methods: {
    getWxWb(){
      this.$axios.post(this.api.about.contact,{},res =>{
        if(res.data){
          this.wbWx.wb=res.data.wb_thumb;
          this.wbWx.wx=res.data.wx_thumb;
          this.groupName=res.data.group_name||'集团化官网首页';

          this.$cookies.remove(this.api.cachePrex+'GroupName');
          this.$cookies.set(this.api.cachePrex+'GroupName', this.groupName);

          const indexSeoInfo = this.$cookies.get(this.api.cachePrex+'Index') || {};
          indexSeoInfo.name = res.data.group_name||'集团化官网首页';
          seoArgs.setSeoArgs(indexSeoInfo);
        }
      },err =>{
        this.data=''
      });
    },
    goUrl(url){
      if(url.length>0){
        window.open(url);
      } 
    },
    getMenuList(){
      this.$axios.post(this.api.index.menus,{},res =>{
        this.menusList=res.data;
      },err =>{
        this.menusList=res.data;
      });
    },
    getBanner(){
      this.$axios.post(this.api.index.banners,{item:'Index'},res =>{
        this.banner=res.data;
      },err =>{
        this.banner=[];
      });
    },
    handleScroll(){
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop // 滚动条偏移量
      if(scrollTop>100){
          this.opacityActive=true;
      }
      else{
          this.opacityActive=false;
      }
    },
  },
  mounted(){
    window.addEventListener('scroll',this.handleScroll)
  },
  created(){
    this.getBanner();
    this.getMenuList();
    this.getWxWb();
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.swiper-out.home-index{height:700px!important;}
.header-banner-box .el-carousel{height:700px!important;}
</style>
<style scoped>
  .show-li{width:200px;background:rgba(255,255,255,1);box-shadow:0px 0px 10px 0px rgba(13,52,130,0.1);border-radius:5px;color:#333;}
  .show-li:hover{box-shadow:0px 0px 10px 0px rgba(13,52,130,0.4);}
  .show-li:nth-child(5n+0){margin-right:0;}
  .show-li .part-link{display:block;margin-bottom:20px;font-size:14px;font-weight:400;}
  .show-li .title-link,.show-li .link-out .part-link:first-child{font-size:18px;font-weight:bold;margin-bottom:20px;}
  .show-li .part-link:hover{color:#0D3482;}
  .show-li:hover .active{color:#0D3482;}
</style>



// WEBPACK FOOTER //
// src/view/index.vue